const project = [
    {
        key: 1,
        img: "./taura.png",
        name: "Taura Application",
        description: "Taura App allows you to call anywhere, be it directly to a landline, someone who doesn’t have a data-capable phone, another country, or even another continent.",
        techStack: ['Flutter', 'Firebase', 'Golang'],
        complete: true,
        liveDeploy: "https://play.google.com/store/apps/details?id=sc.org.taura&hl=en&gl=US",
        // sourceCode: "https://github.com/ssahibsingh/yt-playlist-length"
    },
    {
        key: 2,
        img: "./catchapp.png",
        name: "CatchApp Application",
        description: "CatchApp allows users in Zimbabwe to make local voice calls to fixed and mobile numbers at very low rates and low data usage.",
        techStack: ['Flutter', 'Firebase', 'Golang'],
        complete: true,
        liveDeploy: "https://play.google.com/store/apps/details?id=org.duri.maswerasei&hl=en&gl=US",
        // sourceCode: "https://github.com/ssahibsingh/yt-playlist-length"
    },
    {
        key: 3,
        img: "./nhaka.png",
        name: "Nhaka TV Application",
        description: "Nhaka TV offers a variety of services, including on-demand streaming of movies and TV shows high-definition video quality multiple device support.",
        techStack: ['Flutter', 'Firebase', 'Golang', 'NodeJS'],
        complete: true,
        liveDeploy: "https://play.google.com/store/apps/details?id=org.duri.maswerasei&hl=en&gl=US",
        // sourceCode: "https://github.com/ssahibsingh/yt-playlist-length"
    },
    {
        key: 4,
        img: "./globrtrek.png",
        name: "Globe Trek Web Application",
        description: "Global Trek Adventures, is a premier personal holiday booking agent offering extraordinary experiences worldwide. With an extensive network of partners, we provide exclusive and responsible travel options.",
        techStack: ['PHP', 'Firebase', 'HTML', 'NodeJS', 'CSS', 'MySQL'],
        complete: true,
        liveDeploy: "https://globetrekadventures.world",
        // sourceCode: "https://github.com/ssahibsingh/yt-playlist-length"
    },
    {
        key: 5,
        img: "./fritz.png",
        name: "Fritz Community Care Web Application",
        description: "Fritz Community Care is a community based organisation that seeks to empower the community through education, health and social services.",
        techStack: ['Hugo', 'Firebase', 'HTML', 'NodeJS', 'CSS', 'Sqlite'],
        complete: true,
        liveDeploy: "https://fritzcommunity.com.au",
        // sourceCode: "https://github.com/ssahibsingh/yt-playlist-length"
    },
    {
        key: 6,
        img: "./faricom.png",
        name: "Faricom Website for VoIP Application",
        description: "Faricom is an Australian Service peovider that allows you to call anywhere, be it directly to a landline, someone who doesn’t have a data-capable phone, another country, or even another continent.",
        techStack: ['Hugo', 'Firebase', 'HTML', 'NodeJS', 'CSS'],
        complete: true,
        liveDeploy: "https://faricom.com.au",
        // sourceCode: "https://github.com/ssahibsingh/yt-playlist-length"
    },
]

const otherProjects = [
    {
        // key: 1,
        // link: "https://github.com/PRedemption/whatsapp_clone_flutter",
        // img: "https://github.com/PRedemption/whatsapp_clone_flutter/blob/master/assets/whatsapp_logo.png",
    },
]

const data = { project, otherProjects }
export default data;